import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Templates from './Templates';
import Create from './Create';
import Edit from './Edit';
import Duplicate from './Duplicate';
const TimelineTemplates = ({ canEdit }) => {
  return (
    <Switch>
      <Route exact path="/timeline-templates/create" component={Create} />
      <Route
        exact
        path="/timeline-templates/:id"
        render={(props) => (
          <>
            <Edit {...props} canEdit={canEdit} />
          </>
        )}
      />
      <Route
        exact
        path="/timeline-templates/duplicate/:id"
        render={(props) => (
          <>
            <Duplicate {...props} canEdit={canEdit} />
          </>
        )}
      />
      <Templates canEdit={canEdit} />
    </Switch>
  );
};

export default TimelineTemplates;
